import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconArrowTop = props => (
  <SvgIcon {...props} viewBox="0 0 16 16">
    <path d="m9 16v-12.2l5.6 5.6 1.4-1.4-8-8-8 8 1.4 1.4 5.6-5.6v12.2h2z" />
  </SvgIcon>
);

export default IconArrowTop;



// WEBPACK FOOTER //
// ./src/components/icons/IconArrowTop.js